import styled from "styled-components";

export const CraeteVehicleWrapper = styled.div`
  .searchResult {
    position: relative !important;
    top: 0px !important;
  }
  .form-control {
    border: 1px solid #ced4da !important;
    appearance: none !important;
    border-radius: 0.25rem !important;
  }
  .input-fileds textarea {
    border: 1px solid #979797;
    border-radius: 4px;
  }
  .input-fileds img {
    width: 25px;
    height: 25px;
  }
  .headerContainer {
    justify-content: center !important;
  }
  select {
    border: 1px solid #ced4da !important;
  }
  .colorBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #979797;
    border-radius: 4px;
    padding: 0px 10px;
  }
  .colorBox input {
    border: none;
    width: 20%;
    height: 34px;
  }

  .save-btn h4 {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .add-button {
    white-space: nowrap;
    float: right;
    border: none !important;
    border-radius: 5px;
    background: #fbc524 !important;
    color: #fff !important;
    font-weight: 500;
    font-size: 16px;
    font-weight: bold;
    line-height: 19px;
    padding: 0 20px;
    height: 35px;
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .add-button:hover {
    background: #637df4;
    color: white;
  }
  select {
    border: 1px solid #979797;
    border-radius: 4px;
  }
  .fileInput {
    display: none;
  }
  .suggested-labels{
    margin-top: 30px;
    ul{
      margin-top: 10px;
      li{
        margin: 4px 0 15px;
        span{
          border: 1px solid #607afc;
          color: #607afc;
          font-weight: 600;
          width: max-content;
          padding: 0px 4px 2px;
          border-radius: 4px;
        }
        img{
          cursor: pointer;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .product-type {
      margin-top: 15px;
    }
  }
`;
